import { Link } from "react-router-dom";
import './ProjectHeader.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

export default function ProjectHeader({
path,
headerTitle,
showBackButton = false
})
{
    return (
        <header className="project-header">
              {showBackButton ? (
              <Link
                to={path}
                className="header-link">
                <i className="bi bi-chevron-left"> </i>
                {headerTitle}
              </Link>
              ) : (
                <div className="header-link"> {headerTitle} </div>
              )}
              
        </header>
    )
}